import { gql } from "@apollo/client";

export const AddEmpLdgrAssoic = gql`
  mutation AddEmpLdgrAssoic(
    $token: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
    $ldgrID: ID!
    $empIds: [ID!]!
  ) {
    AddEmpLdgrAssoic(
      token: $token
      customer_id: $customer_id
      user_details: $user_details
      ldgrID: $ldgrID
      empIds: $empIds
    )
  }
`;

export const DeleteEmpLdgrAssoic = gql`
  mutation DeleteEmpLdgrAssoic(
    $token: String!
    $customer_id: ID!
    $user_details: SubscribedUser!
    $ldgrID: ID!
    $empIds: [ID!]!
  ) {
    DeleteEmpLdgrAssoic(
      token: $token
      customer_id: $customer_id
      user_details: $user_details
      ldgrID: $ldgrID
      empIds: $empIds
    )
  }
`;
